import { MilestoneResponse, MilestoneListResponse, CreateMilestoneRequest, UpdateMilestoneRequest } from "@/types/milestoneTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class MilestoneFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByProjectId(projectId: string): Promise<MilestoneListResponse> {
    return this.client.read(`/api/milestones/project/${projectId}`);
  }

  read(id: string): Promise<MilestoneResponse> {
    return this.client.read(`/api/milestones/${id}`);
  }

  create(data: CreateMilestoneRequest): Promise<MilestoneResponse> {
    return this.client.create('/api/milestones', data);
  }

  update(id: string, data: UpdateMilestoneRequest): Promise<MilestoneResponse> {
    return this.client.update(`/api/milestones/${id}`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/milestones/${id}`);
  }
}
